import './c-toggle-true-false-stateless.scss';
import template from './toggle-true-false-stateless.vhtml';

export default {
	template,
	props: {
		label: {
			type: String,
			default: '',
		},
		selected: {
			type: [ String, Number ],
			default: false,
		},
	},
	computed: {
		isSelected() {
			return ( this.selected === '' || this.selected === 0 ) ? false : true;
		},
	},
	methods: {
		toggle() {
			this.$emit( 'select', this.isSelected ? 0 : 1 );
		},     
	},
};



// WEBPACK FOOTER //
// ./assets/_js/components/toggle-true-false-stateless/toggle-true-false-stateless.js